export enum HEADERMENU_PATH {
    login = '/login',
    resendActivateEmail = '/resend-activate-email',
    deals = '/deals',
    signUp = '/sign-up',
    signUpSuccess = '/signup/thank-you',
    accountActivation = '/activate-account',
    referral = '/referral',
    referralTAC = '/referrals/terms-and-conditions',
    dealPayment = '/deal-payment/',
    cessationPlan = '/cessation-plan',
    settings = '/settings',
    repayment = '/repayment/',
    PDFView = '/pdf-view',
    resignNDA = '/resign-nda',
    resignAIConsent = '/resign-aiconsent',
    resignHIPLAIConsent = '/resign-HIPL-aiconsent',
    resignSubscription = '/resign-subscription',
    signAIConsent = '/sign-aiconsent',
    signSubscription = '/sign-subscription',
    signHIPLAIConsent = '/sign-HIPL-aiconsent',
    forgotPassword = '/forgot-password',
    forgotPasswordMessage = '/forgot-password/message',
    resetPassword = '/reset-password',
    referralSignUp = '/referral/',
    activateAccountAndSetPassword = '/activate-account-and-set-password',
    //Onboarding
    onboarding = '/onboarding',
    oauth2 = '/federated-login',
    accountActivationWithOtp = '/account-activation',
    postAgreements = '/post-agreements',
    myinfoRedirect = '/kyc/myinfo',
    //Investment
    investments = '/portfolio',
    //5th-anniversary-rebate
    rebate = '/5th-anniversary-rebate',
    faq = '/faq',
    accessDenied = '/accessDenied',
}
